// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__131qZ","infoBtn":"quickbooks_infoBtn__2YuNN","formBox":"quickbooks_formBox__3IZFQ","formFooter":"quickbooks_formFooter__2Pc3P"};